import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Icon from "../../assets/Icon";
import { Fragment, useState } from "react";
import ParagraphText from "../ParagraphText";

export default function AppInputDropDown({
  filterOptions = undefined,
  RenderInput,
  className,
  suffix,
  data,
}) {
  const {
    fromEdit = false,
    onChangeText,
    placeholder,
    disabled,
    title,
    value,
    error,
    list,
    id,
    required
  } = data || {};
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`formInputBox inputFormBox ${className}`}>
      <div className='inputFormBoxInner inputDropDown'>
        <div className='inputFormBoxMain'>
          {Boolean(title) && <Fragment>
            <ParagraphText className={"mb-2 fontSize14 newFontColor"}>
              {title}{required && <span style={{ color: "red" }}>*</span>}
            </ParagraphText>
          </Fragment>}
          <Autocomplete
            getOptionLabel={(option) =>
              option?.reason || option?.name || option
            }
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            onChange={(e, select) => onChangeText(title, select)}
            options={list || []}
            includeInputInList
            closeIcon={false}
            value={disabled ? null : value || null}
            disabled={disabled || fromEdit}
            autoComplete
            filterOptions={filterOptions}
            id={id}
            renderInput={
              RenderInput ??
              ((params) => (
                <TextField
                  {...params}
                  placeholder={placeholder ? title : ""}
                  variant='outlined'
                />
              ))
            }
          />
          <span className='sufixIcon'>
            <Icon data={suffix} />
          </span>
        </div>
        <p className='inputError'>{error ? error : null}</p>
      </div>
    </div>
  );
};
